(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('store-file-manager', {
            parent: 'admin',
            url: '/store-file-manager',
            data: {
                pageTitle: 'file-manager.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/file-manager/store-file-manager.html',
                    controller: 'StoreFileManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file-manager');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
